export const reportStatusClasses = {
  status: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 12px 0px',
    gap: '10px',
    width: 'auto',
    maxWidth: '350px',
    height: '26px',
    background: '#E8F0FD',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-md)'
  },
  inProgress: {
    background: '#E8F0FD'
  },
  success: {
    color: '#368759',
    backgroundColor: '#F0F9F4',
    border: 'var(--border-neutral-thin)'
  },
  warning: {
    color: '#E57373',
    backgroundColor: '#FAEAEA',
    border: 'var(--border-width-thin) var(--border-style-solid) var(--color-warning-500)'
  },
  shared: {
    color: '#AAAAAA',
    backgroundColor: '#EEEEEE',
    border: 'var(--border-neutral-normal)'
  }
}
